import React from "react";
import _ from "lodash";
import { EMAIL_SUFFIX } from "Source/components/project/Config/Config";

class EmailInputContainer extends React.Component {
    constructor(props) {
        super(props);
    }
 
    render() {
        const {label, errorMessage, valid, suffix = '' }= this.props;
        const suffixContent = suffix
            ?  `-${suffix}`
            : null;

        return (
            <div class="formSection">
                <div class="formContainer">
                    <label>{label}<sup>*</sup></label>

                    <div class={`emailInputContainer ${!valid  ? "hasError" : ""}`}>
                        {this.props.children}
                        <span>{suffixContent? suffixContent: '@'+ EMAIL_SUFFIX}</span>
                    </div>
                    
                    {errorMessage && !valid 
                        &&  <span class="errorMsg">{errorMessage}</span>
                    }
                </div>
            </div>
        );
    }
}

export default EmailInputContainer;
